import { useEffect, useState } from "react";
import { motion, useAnimation } from "framer-motion";
import HeaderCompact from "./HeaderCompact";

const Landing = () => {
  const stick1 = useAnimation();
  const stick2 = useAnimation();
  const fullText = "Achieve flawless skin with our cosmetologist";
  const [displayedText, setDisplayedText] = useState("");

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // typing text effect
  useEffect(() => {
    const printed = localStorage.getItem("typingTextDone");
    if (printed) {
      setDisplayedText(fullText);
    } else {
      const timeout = setTimeout(() => {
        let index = 0;
        const interval = setInterval(() => {
          setDisplayedText((prev) => {
            if (index < fullText.length) {
              const nextChar = fullText[index];
              index++;
              return prev + nextChar;
            } else {
              clearInterval(interval);
              localStorage.setItem("typingTextDone", "true");
              return prev;
            }
          });
        }, 50);
      }, 1000);

      return () => clearTimeout(timeout);
    }

    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 300) {
        setDisplayedText("");
        localStorage.removeItem("typingTextDone");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // stick animations
  useEffect(() => {
    stick1
      .start({
        opacity: 1,
        y: 120,
        x: 0,
        scale: 0.8,
        transition: { duration: 1.2, delay: 1, ease: "easeInOut" },
      })
      .then(() => {
        stick1.start({
          rotateZ: [0, 10, -10, 0],
          transition: { duration: 2, ease: "easeInOut", repeat: Infinity },
        });
      });

    stick2
      .start({
        opacity: 1,
        y: -130,
        x: 0,
        scale: 0.8,
        transition: { duration: 1.2, delay: 1, ease: "easeInOut" },
      })
      .then(() => {
        stick2.start({
          rotateZ: [0, 10, -10, 0],
          transition: { duration: 2, ease: "easeInOut", repeat: Infinity },
        });
      });
  }, [stick1, stick2]);

  const getX = () => {
    if (screenWidth >= 768) return "-95px";
    if (screenWidth >= 350) return "-95.5px";

    return "-10vw"; // для экранов меньше 400
  };
  return (
    <div className="w-full min-h-screen flex flex-col overflow-hidden relative px-4 pt-4 sm:px-6 lg:px-12">
      {/* Header */}
      <HeaderCompact />

      {/* Text */}
      <h1 className="text-4xl lg:text-5xl w-full text-center font-normal text-gray-800 mb-4">
        Your <span className="text-pink-400">✨AI-powered</span>
        <br /> skincare App
      </h1>
      <p className="text-gray-400 mb-8 text-center text-sm lg:text-lg">
        {displayedText}
        <span className="inline-block ml-1 animate-pulse">|</span>
      </p>

      {/* Graphics */}
      <div className="relative w-full h-[750px] flex justify-center items-center">
        {/* iPhone */}
        <motion.img
          loading="lazy"
          src="/iPhoneLanding.svg"
          alt="iPhone"
          className="w-[300px] max-w-[280px]"
          style={{
            transformPerspective: 800,
            willChange: "transform, opacity",
          }}
          initial={{ rotateX: 45, rotateY: 0, rotateZ: 0, y: -100 }}
          animate={{ rotateX: 0, rotateY: 0, rotateZ: 0 }}
          transition={{ duration: 1.2, delay: 1, ease: "easeInOut" }}
        />

        {/* Left Girl */}
        <motion.img
          loading="lazy"
          src="/girlLeft.webp"
          alt="Girl Left"
          className="absolute w-[185px]  max-w-[220px] xss:top-[32%] xss:left-[5%] sm:top-[30%] sm:left-[30%] md:top-[30%] md:left-[35%]"
          style={{
            transform: "translateY(-50%)",
            willChange: "transform, opacity",
          }}
          initial={{ rotateX: 0, rotateY: 0, rotateZ: -9 }}
          animate={{ x: "-100%", opacity: 0 }}
          transition={{ duration: 1.2, delay: 1, ease: "easeInOut" }}
        />

        {/* Right Girl */}
        <motion.img
          loading="lazy"
          src="/girlRight.webp"
          alt="Girl Right"
          className="absolute w-[185px]  max-w-[220px] top-[30%] left-1/2"
          initial={{ rotateX: 0, rotateY: 0, rotateZ: 9 }}
          animate={{
            rotateX: 0,
            rotateY: 0,
            rotateZ: 0,
            scale: 1.4,
            x: getX(), // смещение только на больших экранах
            y: "-70px",
          }}
          transition={{ duration: 1, delay: 1, ease: "easeInOut" }}
          style={{ willChange: "transform, opacity" }}
        />

        {/* Stickers */}
        <motion.img
          loading="lazy"
          src="/perfectFit.webp"
          alt="Perfect Fit"
          className="absolute w-[120px] xss:top-[25%] xss:left-[10%] xs:top-[25%] xs:left-[20%] sm:top-[25%] sm:left-[26%] md:top-[25%] md:left-[35%]"
          initial={{ opacity: 0 }}
          animate={stick2}
          style={{ willChange: "transform, opacity" }}
        />
        <motion.img
          loading="lazy"
          src="/goGirl.webp"
          alt="Go Girl"
          className="absolute w-[120px] xss:top-[35%] xss:right-[15%] xs:top-[35%] xs:right-[25%] z-10 sm:top-[35%] sm:right-[33%] md:right-[37%] md:top-[35%]"
          initial={{ opacity: 0 }}
          animate={stick1}
          style={{ willChange: "transform, opacity" }}
        />
      </div>
    </div>
  );
};

export default Landing;
